// eslint-disable-next-line import/prefer-default-export
export const GetProgramMemberSelector = ({
  programMember: { GetProgramMember }
}) => GetProgramMember;

export const PostProgramMemberSelector = ({
  programMember: { PostProgramMember }
}) => PostProgramMember;

export const GetDataSystemDropdownValuesSelector = ({
  programMember: { GetDataSystemDropdownValues }
}) => GetDataSystemDropdownValues;
